import {Component, EventEmitter, OnChanges, OnInit, Input, Output, SimpleChanges} from '@angular/core';
import { MATERIAL_LIST_IMPORTS } from '../material-list.config';

interface IColumnToSelect {
    name: string;
    completed: boolean;
    columns?: IColumnToSelect[]
}
@Component({
    selector: 'column-selector',
    standalone: true,
    imports: [...MATERIAL_LIST_IMPORTS],
    templateUrl: './column-selector.component.html',
    styleUrls: ['./column-selector.component.scss']
})
export class ColumnSelectorComponent implements OnInit, OnChanges {
    @Input('columns') public _column_list: string[] = [];
    @Input('default') public _column_default: string[] = [];
    @Input('selected') public _column_selected: string[] = [];
    @Output('onChange') private _onChange_event = new EventEmitter<string[]>();

    public columns_to_select: IColumnToSelect = {
        name: 'Seletccionar todas',
        completed: false,
        columns: []
    };

    allComplete: boolean = false;

    // =========================================================================
    // -------------------------------------------------------------------------
    constructor() {}

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
    
        if (changes['_column_list']) {
            this._resetAll();
            this._setAll(changes['_column_list'].currentValue);
        }

    }
    
    // =========================================================================
    public sectionClick($event: any) {

        $event.stopPropagation();
    
    }
    
    // -------------------------------------------------------------------------
    public resetDefaultsColumns() {

        this.columns_to_select.columns && this.columns_to_select.columns.forEach(
            (e) => {
                e.completed = this._column_default.includes(e.name)
            }
        );
        
        this._onChange_event.emit(undefined);
    
    }

    // -------------------------------------------------------------------------
    public updateAllComplete() {
        this.allComplete = this.columns_to_select.columns != null && this.columns_to_select.columns.every(t => t.completed);
        this._sendChangeEvent();
    }
    
    public someComplete(): boolean {
        if (this.columns_to_select.columns == null) {
            return false;
        }
        return this.columns_to_select.columns.filter(t => t.completed).length > 0 && !this.allComplete;
        this._sendChangeEvent();
    }

    public setAll(completed: boolean) {
        this.allComplete = completed;
        if (this.columns_to_select.columns == null) {
            return;
        }
        this.columns_to_select.columns.forEach(t => (t.completed = completed));
        this._sendChangeEvent();
    }

    // =========================================================================
    // -------------------------------------------------------------------------
    private _resetAll(): void {
        
        this.columns_to_select.columns = [];
        // this.selected = [];
    }
    
    // -------------------------------------------------------------------------
    private _setAll(new_columns: string[]): void {
        
        this.columns_to_select.columns = new_columns.map( (e:string) => this._createColumnToSelect(e));
        // this.selected = [];
    }
    
    // -------------------------------------------------------------------------
    private _createColumnToSelect(name: string): IColumnToSelect {
        return {
            name: name,
            completed: this._column_selected.includes(name)
        };
        
    }
    
    // -------------------------------------------------------------------------
    private _sendChangeEvent(): void {
        if (this.columns_to_select.columns) {
            let selected = this.columns_to_select.columns.map( (e:IColumnToSelect) => (e.completed?e.name:''));
            selected = selected.filter( (e:string) => (e!='') )
            this._onChange_event.emit(selected);
        }
        
    }
    
}
